module.exports = __webpack_public_path__ + "img/felhound_shrine_small.23d5680c.png";